import script from "./QuizResultComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuizResultComponent.vue?vue&type=script&lang=ts&setup=true"

import "./QuizResultComponent.vue?vue&type=style&index=0&id=291a477f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-291a477f"]])

export default __exports__